export default "__VITE_ASSET__0324e023__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg17__"